<template>
  <v-card class="mt-2">
    <v-alert
      class="text-left pt-5"
      dense
      border="top"
      colored-border
      type="warning"
    >
      {{ message }}
    </v-alert>
    <v-card-text class="pt-0">
      <v-row>
        <v-col cols="12" lg="4">
          <v-btn block color="primary" href="tel:+16474592887">
            <v-icon left>mdi-phone</v-icon> Call Now
          </v-btn>
          <!-- <small class="d-inline-block mt-1" style="line-height: 1.2">
            This will allow users to call DriverX
          </small> -->
        </v-col>
        <v-col cols="12" lg="4">
          <v-btn block color="primary" href="mailto:ontariodriverx@gmail.com">
            <v-icon left>mdi-email</v-icon> Email Now
          </v-btn>
          <!-- <small class="d-inline-block mt-1" style="line-height: 1.2">
            This will allow to email driverX from the email client
          </small> -->
        </v-col>
        <v-col cols="12" lg="4">
          <v-dialog v-model="textDialog" width="500" persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn block color="primary" v-bind="attrs" v-on="on">
                <v-icon left>mdi-chat</v-icon> Text Now
              </v-btn>
            </template>
            <v-form @submit="sendTextMessage" ref="textForm">
              <v-card>
                <v-card-text class="py-0">
                  <v-textarea
                    v-model="text"
                    :hint="`${text.length} / 300`"
                    :rules="fieldRules"
                    placeholder="Please give us some more information so that we can match you with a nearby instructor. Include your location and availability."
                  />
                </v-card-text>
                <v-card-actions>
                  <v-btn @click="textDialog = false">Cancel</v-btn>
                  <v-spacer />
                  <v-btn color="primary" type="submit"> Send </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <!-- <small class="d-inline-block mt-1" style="line-height: 1.2">
            This will allow students to send a text message
          </small> -->
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    message: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      textDialog: false,
      text: '',
      fieldRules: [
        (v) => !!v || 'This field is required',
        (v) => v?.length <= 300 || 'Max limit 300 characters'
      ]
    }
  },
  computed: {
    ...mapGetters(['user', 'sms'])
  },
  methods: {
    ...mapActions(['sendSMS', 'toggleDialog']),
    async sendTextMessage () {
      var phone = this.user.get('phone')
      var name = this.user.get('firstName') + ' ' + this.user.get('lastName')
      this.text =
        'New text message from ' +
        name +
        ' with the phone number ' +
        phone +
        ' sent the following message: ' +
        "'" +
        this.text +
        "'"
      if (this.$refs.textForm.validate()) {
        await this.sendSMS({ message: this.text })
        this.textDialog = false
        if (this.sms) {
          this.toggleDialog({
            status: true,
            title: 'Success',
            message:
              'Thank you for contacting DriverX. We will get back to you soon.'
          })
        }
      }
    }
  }
}
</script>
